import React from 'react'
import PropTypes from 'prop-types'
import {FLOORS} from 'lib/enumMapping'

class WalkthroughProduct extends React.Component {
  static propTypes = {
    webOrder: PropTypes.object.isRequired,
    onChange: PropTypes.func,
  }

  componentDidMount() {
    this.props.onChange({
      dependentProducts: [
        {
          __typename: 'FloorPlansProduct',
          floors: this.numberOfEstateFloors,
          measurement: true,
        }
      ]
    })
  }

  get numberOfEstateFloors() {
    if (FLOORS[this.estateFloors]) {
      return parseInt(FLOORS[this.estateFloors], 10)
    }
    return 1
  }

  // Floors can be defined on either an existing estate the web order is
  // based on, or on the web order itself if there is no existing estate.
  get estateFloors() {
    const {webOrder} = this.props
    return webOrder.estate && webOrder.estate.floors
      ? webOrder.estate.floors
      : webOrder.floors
  }

  render() {
    return (
      <div>
        Ved bestilling av 360 Visning vil også Plantegning m/ oppmåling bli lagt til,
        da disse produktene er knyttet sammen.
      </div>
    )
  }
}

export default WalkthroughProduct
